/**
 * Cookie Utility Functions
 *
 * Handles browser cookie operations.
 */

/**
 * Get a cookie value by name
 */
export function getCookie(name: string): string {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");

  for (const raw of ca) {
    const c = raw.trimStart();
    if (c.startsWith(nameEQ)) {
      return c.substring(nameEQ.length);
    }
  }

  return "";
}

/**
 * Set a cookie
 *
 * @param name - Cookie name
 * @param value - Cookie value
 * @param days - Number of days until expiry
 */
export function setCookie(name: string, value: string, days: number): void {
  let expires = "";

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  document.cookie = name + "=" + (value ?? "") + expires + "; path=/";
}
